/**
 * BHCR digit pop-in for dynamic numbers (prices, counts, totals).
 * Replaces element text with per-character animation on update.
 */
(function () {
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedMotionQuery.matches;
  }

  function readText(element) {
    if (!element) return '';
    const group = element.querySelector(':scope > .bhcr-digit-group');
    if (group) return group.textContent;
    return element.textContent;
  }

  function buildDigitGroup(text) {
    const group = document.createElement('span');
    group.className = 'bhcr-digit-group';

    [...text].forEach((char, index) => {
      const digit = document.createElement('span');
      digit.className = 'bhcr-digit';
      digit.textContent = char;
      // Match Transitions.dev: first two digits pop in together, then stagger.
      if (index >= 2) {
        digit.dataset.stagger = String(index - 1);
        digit.style.setProperty('--digit-delay', `calc(var(--digit-stagger) * ${index - 1})`);
      }
      group.appendChild(digit);
    });

    return group;
  }

  function set(element, text, options = {}) {
    if (!element) return;

    const next = String(text ?? '');
    const previous = readText(element);

    if (!options.force && next === previous) return;

    if (prefersReducedMotion()) {
      element.textContent = next;
      return;
    }

    element.textContent = '';
    const group = buildDigitGroup(next);
    element.appendChild(group);
    void group.offsetWidth;
    group.classList.add('is-animating');
  }

  function revealIn(root, selector = '[data-digit-animate]') {
    if (!root || !(root instanceof Element)) return;

    const elements = new Set();
    if (root.matches(selector)) elements.add(root);
    root.querySelectorAll(selector).forEach((element) => elements.add(element));

    elements.forEach((element) => {
      const text = readText(element);
      if (!text) return;
      set(element, text, { force: true });
    });
  }

  window.BhcrDigitAnimate = {
    set,
    revealIn,
    readText,
    prefersReducedMotion,
  };
})();
